import React, { useState, useEffect } from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AdminSettingsDataService from "../../../services/admin-settings.service";
import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button, Modal, Select, Spin, Tooltip } from "antd";


export const EmailTemplate = (props) => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [visible, setVisible] = useState(false);
  const [content, setContent] = useState("");
  const [dealerId, setDealerId] = useState(0);
  const loginDetials = useSelector((state) => state.loginReducer);
  const [dealerList, setDealerList] = useState([]);
  const [typeName, setTypeName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [isCommunityEmails, setIsCommunityEmails] = useState(true);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
        }
      }
    }
    handleFillDealerDropDown();
  }, []);

  const onChange = (value) => {
    setDealerId(value);
    handleGetEmailDealerStatus(value);
  };

  const handleFillDealerDropDown = () => {
    try {
      AdminToolsDataService.FillDealerDropDown()
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setDealerList(responseData);
          } else {
            setDealerList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetEmailTemplatesById = (name) => {
    let inputParams = {
      DealerID: dealerId,
      TypeName: name,
    };
    setContent("");
    setTypeName(name);
    setVisible(true);
    setLoading(true);
    AdminSettingsDataService.GetEmailTemplatesById(inputParams)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (responseData[0]) {
            setContent(responseData[0].emailContent);
          }
        } else {
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleSaveEmailTemplate = () => {
    let inputParams = {
      dealerID: dealerId,
      typeName: typeName,
      eMailContent: content,
    };
    AdminSettingsDataService.SaveEmailTemplate(inputParams)
      .then((response) => {
        var message = response.data.message;
        if (message == "RECORD UPDATED SUCESSFULLY") {
          handleCloseModal();
          NotificationManager.success(
            t("Email template has been saved successfully.")
          );
        } else {
          NotificationManager.error(t("Email template has not been updated."));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetEmailDealerStatus = (id) => {
    let inputParams = {
      dealerID: id,
    };
    setPageLoading(true);
    AdminSettingsDataService.GetEmailDealerStatus(inputParams)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setIsCommunityEmails(responseData);
        } else {
          setIsCommunityEmails(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setPageLoading(false);
      })
      .finally(() => {
        setPageLoading(false);
      });
  };
  const handleCloseModal = () => {
    setContent("");
    setVisible(false);
  };
  return (
    <div className="form__fields">
      <Spin spinning={pageLoading}>
        <div className="row">
          <div className="col-md-12">
            <h4 className="workarea__heading mt-0 mb-3">
              {" "}
              {t("Email Templates")}{" "}
            </h4>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="input__block">
              <label> {t("All Dealers")} </label>
              <Select
                className="border__grey"
                showSearch
                placeholder={t("Select Dealer")}
                optionFilterProp="children"
                notFoundContent={t("No Data Found")}
                value={dealerId}
                onChange={onChange}
              >
                <Option value={0}>--{t("All Dealer")}--</Option>
                {dealerList.map((item) => {
                  return (
                    <Option value={item.dealerID}>
                      {item.dealerCompany + " (" + item.dealerID + " )"}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        </div>

        <div className="emailTemplate">
          <div className="row">
            {dealerId == 0 ? (
              <div className="col-md-4 mb-4">
                <div className="emailDetailBlock">
                  <h1> {t("Registration Emails")} </h1>
                  <ul>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("NewAccount")
                        }
                      >
                        {t("New Account")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("ForgotPassword")
                        }
                      >
                        {t("Forgot Password")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("ResetPassword")
                        }
                      >
                        {t("Reset Password")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("ForgotUserName")
                        }
                      >
                        {t("Forgot UserName")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("lockedAccount")
                        }
                      >
                        {t("Account Locked")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            ) : null}

            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Retailer Emails")} </h1>
                <ul>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("InviteNewRetailer")
                      }
                    >
                      {t("Invite New Retailer")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {dealerId == 0 || isCommunityEmails ? (
              <div className="col-md-4 mb-4">
                <div className="emailDetailBlock">
                  <h1> {t("Community Emails")} </h1>
                  <ul>
                    <li>
                      <a onClick={() => handleGetEmailTemplatesById("Active")}>
                        {t("Retailer Request e-Mail to")} "{t("ACTIVE")}"{" "}
                        {t("GF Members")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("CommunityManaged")
                        }
                      >
                        {t("Retailer e-Mail to")} "{t("COMMUNITY MANAGED")}"{" "}
                        {t("Non GF Members")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("ProfileOnly")
                        }
                      >
                        {t("Retailer e-Mail to")} "{t("PROFILE ONLY")}"{" "}
                        {t("Non GF Members")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("LimitedAccount")
                        }
                      >
                        {t("Retailer e-Mail to")} "{t("LIMITED ACCOUNT")}"{" "}
                        {t("GF Members")}
                      </a>
                    </li>
                    <li>
                      <a onClick={() => handleGetEmailTemplatesById("Decline")}>
                        {t("Vendor Decline eMail")}
                      </a>
                    </li>
                    <li>
                      <a onClick={() => handleGetEmailTemplatesById("Accept")}>
                        {t("Vendor Accept eMail")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("UpdateProductData")
                        }
                      >
                        {t("Request to Update Product Data")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("VendorAppointment")
                        }
                      >
                        {t("Vendor Appointment")}
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() =>
                          handleGetEmailTemplatesById("InviteNewVendor")
                        }
                      >
                        {t("Invite New Vendor")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            ) : null}

            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Contact Emails (MasterLink)")}</h1>
                <ul>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("CustomerRegistration")
                      }
                    >
                      {t("Customer Registration")}
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("CustNewAppointments")
                      }
                    >
                      {t("New Appointments")}
                    </a>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Inquires (Request More Info)")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "CustMoreInfoRetailer"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("CustMoreInfoSender")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Send Email (Email To Friend)")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("ToFriendInquires")
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("CustInquires")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("ToSenderInquires")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Drop A Hint")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "ToRecipientDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("ToRetailerDropAHint")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("CustNewFavoriteList")
                      }
                    >
                      {t("New Favorite List")}
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("CustNewFavoriteItem")
                      }
                    >
                      {t("New Favorite Items Added")}
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("CustConversations")
                      }
                    >
                      {t("Conversations")}
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("CustResetPassword")
                      }
                    >
                      {t("Customer Reset Password")}
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("CustResetPasswordNew")
                      }
                    >
                      {t("Customer Reset Password (New)")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Diamond Search Emails")} </h1>
                <ul>
                  <li>
                    <div>
                      <h2> {t("Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "DSToRetailerInquires"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("DSToSenderInquires")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Email To Friend")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("DSToFriendEmailF")
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("DSToRetailerEmailF")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("DSToSenderEmailF")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Drop A Hint")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "DSToRecipientDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "DSToRetailerDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Schedule View")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "DLToScheduleViewDiamondDetail"
                              )
                            }
                          >
                            {t("Diamond Detail")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("DiamondCompare")
                      }
                    >
                      {t("Diamond Compare")}
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() =>
                        handleGetEmailTemplatesById("DiamondCustomerCompare")
                      }
                    >
                      {t("Diamond Customer Compare")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Fancy Color Diamond Search Emails")} </h1>
                <ul>
                  <li>
                    <div>
                      <h2> {t("Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "FCToRetailerInquires"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("FCToSenderInquires")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Email To Friend")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("FCToFriendEmailF")
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("FCToRetailerEmailF")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("FCToSenderEmailF")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Drop A Hint")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "FCToRecipientDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "FCToRetailerDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Schedule View")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "DLToScheduleViewColorDiamondDetail"
                              )
                            }
                          >
                            {t("Color Diamond Detail")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Ring Builder Emails")} </h1>
                <ul>
                  <li>
                    <div>
                      <h2> {t("Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRetailerInquires"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("RBToSenderInquires")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Email To Friend")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("RBToFriendEmailF")
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("RBToRetailerEmailF")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("RBToSenderEmailF")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Drop A Hint")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRecipientDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRetailerDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Drop A Hint (Infinity)")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRecipientDropAHintInfinity"
                              )
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRetailerDropAHintInfinity"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToSenderDropAHintInfinity  "
                              )
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Buy Now (Infinity)")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRetailerBuyNowInfinity"
                              )
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToSenderBuyNowInfinity"
                              )
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Schedule View")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToScheduleViewSetting"
                              )
                            }
                          >
                            {t("Setting Detail")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToScheduleViewDiamondDetail"
                              )
                            }
                          >
                            {t("Diamond Detail")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToScheduleViewComplete"
                              )
                            }
                          >
                            {t("Complete Ring Specifications")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Pendant Builder Emails")} </h1>
                <ul>
                  <li>
                    <div>
                      <h2> {t("Diamond Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "PBDiamondToRetailerInquires"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "PBDiamondToSenderInquires"
                              )
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "PBToRetailerInquires"
                              )
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("PBToRetailerEmailF")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Email To Friend")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("PBToFriendEmailF")
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("PBToRetailerEmailF")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("PBToSenderEmailF")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Drop A Hint")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "PBToRecipientDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "PBToRetailerDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li>
                    <div>
                      <h2> {t("Schedule View")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "PBToScheduleViewDiamondDetail"
                              )
                            }
                          >
                            {t("Diamond Detail")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "PBToScheduleViewComplete"
                              )
                            }
                          >
                            {t("Complete Pendant Setting")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Stud Builder Emails")} </h1>
                <ul>
                  <li>
                    <div>
                      <h2> {t("Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBToRetailerInquires"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("SBToSenderInquires")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Email To Friend")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("SBToFriendEmailF")
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("SBToRetailerEmailF")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("SBToSenderEmailF")
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Drop A Hint")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBToRecipientDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBToRetailerDropAHint"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRecipientDropAHintInfinity"
                              )
                            }
                          >
                            {t("Request More Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "RBToRetailerDropAHintInfinity"
                              )
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li>
                    <div>
                      <h2> {t("Schedule View")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("SBToScheduleView")
                            }
                          >
                            {t("SB To ScheduleView")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBToScheduleViewComplete"
                              )
                            }
                          >
                            {t("SB Complete Earring To ScheduleView")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Diamond Request More Info")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBDiamondToRetailerInquires"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBDiamondToSenderInquires"
                              )
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Diamond Email To Friend")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBDiamondToFriendEmailF"
                              )
                            }
                          >
                            {t("Send Mail to Friend")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBDiamondToRetailerEmailF"
                              )
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBDiamondToSenderEmailF"
                              )
                            }
                          >
                            {t("Send Mail to Sender")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Diamond Drop A Hint")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBDiamondToRecipientDropAHint"
                              )
                            }
                          >
                            {t("Send Mail To Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById(
                                "SBDiamondToRetailerDropAHint"
                              )
                            }
                          >
                            {t("Send Mail To Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <div>
                      <h2> {t("Store")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("SBToSenderStore")
                            }
                          >
                            {t("Send Mail to Recipient")}
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("SBToRetailerStore")
                            }
                          >
                            {t("Send Mail to Retailer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="emailDetailBlock">
                <h1> {t("Big Emails")} </h1>
                <ul>
                  <li>
                    <div>
                      <h2> {t("Email To Customer")} </h2>
                      <ul>
                        <li>
                          <a
                            onClick={() =>
                              handleGetEmailTemplatesById("BGCustomermail")
                            }
                          >
                            {t("Send Mail to Customer")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <Modal
          className="emailTemplateEditorModal"
          title={t("Send Email")}
          centered
          visible={visible}
          onOk={handleSaveEmailTemplate}
          onCancel={handleCloseModal}
          width={800}
          hieght={600}
          footer={[
            <Button key="back" onClick={handleCloseModal}>
              {t("Cancel")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={handleSaveEmailTemplate}
            >
              {t("Save")}
            </Button>,
          ]}
        >
          <div className="editor__section">
            <Spin spinning={loading}>
              <CKEditor
                editor={ClassicEditor}
                data={content ? content : ""}
                id="editor"
                onReady={(editor) => {}}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setContent(data);
                }}
              />
            </Spin>
          </div>
        </Modal>
      </Spin>
    </div>
  );
};
export default EmailTemplate;
